import React, { Component } from 'react';
import style from './progressbar.less';
import { getQuestionsQuantity } from '../../questionnaire.utils.jsx';

export default class Progressbar extends Component {
    constructor() {
        super();
        this.availableProgressPercent = 0;
        this.passedProgressPercent = 0;
        this.lastPassedPageIndex = 0;
        this.countProgress = this.countProgress.bind(this);
    }
    UNSAFE_componentWillUpdate(nextProps) {
        const { pageList, fields } = this.props;
        let passedProgressPercent = 0,
            availableProgressPercent = 0;
        const questionsQuantity = getQuestionsQuantity(pageList, fields);
        const passedPageIndex = nextProps.lastPageIndex - 1;
        if (1 === nextProps.lastPageIndex - passedPageIndex && 0 < pageList.length) {
            for (let page = 0; page <= nextProps.lastPageIndex; page++) {
                passedProgressPercent = nextProps.lastPageIndex !== page ? passedProgressPercent += 100 / questionsQuantity * pageList[page].questionsQuantity : passedProgressPercent;
                availableProgressPercent += 100 / questionsQuantity * pageList[page].questionsQuantity;
            }
        } else if (0 < pageList.length) {
            availableProgressPercent = 100 / questionsQuantity * pageList[0].questionsQuantity;
        }
        this.passedProgressPercent = passedProgressPercent;
        this.availableProgressPercent = availableProgressPercent;
    }
    countProgress() {
        const availableProgress = { width: `${this.availableProgressPercent}%` };
        const passedProgress = { width: `${this.passedProgressPercent}%` };
        return { availableProgress, passedProgress };
    }
    render() {
        const { availableProgress, passedProgress } = this.countProgress();
        const error = this.props.errorText ? (
          <div className={style.progressbar__text}><b>{this.props.errorText}</b></div>
        ) : null;
        const passed = error ? null : (
          <div style={passedProgress} className={style.progressbar__passed}></div>
        );
        const available = error ? null : (
          <div style={availableProgress} className={style.progressbar__available}></div>
        );
        return (
            <div className={style.progressbar}>
                <div className={error ? style.progressbar__wrapper__error : style.progressbar__wrapper }>
                    { error }
                    { available }
                    { passed }
                </div>
            </div>
        );
    }
}
